import { PhoneIcon } from "@heroicons/react/solid";
import React from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import { IconWithText } from "../system/icons/Icon";
import phoneNumberLink from "./phoneNumberLink";
import { Listing } from "./types";

function ProviderListing({ id, displayName, phoneNumber, address }: Listing) {
  const renderAddress = () => {
    if (!address) return null;

    const {
      addressLine1,
      addressLine2,
      addressLine3,
      suburb,
      postcode,
      state,
    } = address;

    return (
      <div className="mb-2" data-testid="address">
        <div>
          {addressLine1 && `${addressLine1}, `}
          {addressLine2 && `${addressLine2}, `}
          {addressLine3 && `${addressLine3}`}
        </div>
        <div>{`${suburb} ${postcode} ${state}`}</div>
      </div>
    );
  };

  const renderPhoneNumber = () => {
    if (!phoneNumber) return null;
    return (
      <IconWithText icon={<PhoneIcon />}>
        <a
          className="link"
          href={phoneNumberLink(phoneNumber)}
          data-testid="phone-number"
          onClick={async (e) =>
            ReactGA.event({
              category: "KeepSight - Provider List",
              action: "Call",
            })
          }
        >
          {phoneNumber}
        </a>
      </IconWithText>
    );
  };

  return (
    <li className="p-4 shadow-md mb-2" data-testid="provider-listing">
      <div className="mb-2" data-testid="display-name">
        <Link to={id} className="link font-bold">
          {displayName}
        </Link>
      </div>
      {renderAddress()}
      {renderPhoneNumber()}
    </li>
  );
}

export default ProviderListing;
